import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';

export interface PdfExportColumn {
  key: string;
  label: string;
}

// Shared by any p-table "Export to PDF" button (projects, tasks, ...) - callers are responsible for
// resolving each row's currently-filtered/visible data and formatting each cell into a plain string
// the same way the table itself renders it, then handing that off here to lay out and download.
@Injectable({
  providedIn: 'root'
})
export class TablePdfExportService {

  Export(title: string, columns: PdfExportColumn[], rows: string[][], filename: string) {
    const doc = new jsPDF({ orientation: columns.length > 6 ? 'landscape' : 'portrait' });

    doc.setFontSize(14);
    doc.text(title, 14, 15);
    doc.setFontSize(9);
    doc.setTextColor(120);
    doc.text(`Exported ${new Date().toLocaleString()} — ${rows.length} record${rows.length === 1 ? '' : 's'}`, 14, 21);

    autoTable(doc, {
      startY: 26,
      head: [columns.map(c => c.label)],
      body: rows,
      styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
      headStyles: { fillColor: [13, 110, 253] },
      alternateRowStyles: { fillColor: [246, 248, 252] },
    });

    doc.save(filename);
  }
}
